import PasswordView from "./PasswordView";
export default PasswordView;